import type { BenchmarkSymbol, Ticker, WindowKey } from '@meridian/contracts';

import { ROOT_KEY } from './root';

export const stockKeys = {
  all: [...ROOT_KEY, 'stock'] as const,
  security: (ticker: Ticker, window: WindowKey) =>
    [...stockKeys.all, 'security', ticker, window] as const,
  series: (ticker: Ticker, window: WindowKey) =>
    [...stockKeys.all, 'series', ticker, window] as const,
  peers: (ticker: Ticker, window: WindowKey) =>
    [...stockKeys.all, 'peers', ticker, window] as const,
  diversifiers: (ticker: Ticker, window: WindowKey) =>
    [...stockKeys.all, 'diversifiers', ticker, window] as const,
  ohlc: (ticker: Ticker, asOf: string | null, window: WindowKey) =>
    [...stockKeys.all, 'ohlc', ticker, asOf, window] as const,
  benchmarkOhlc: (symbol: BenchmarkSymbol, asOf: string | null, window: WindowKey) =>
    [...stockKeys.all, 'benchmark-ohlc', symbol, asOf, window] as const,
  search: (q: string, limit: number) => [...stockKeys.all, 'search', q, limit] as const,
};
